import React, { useEffect, useMemo, useState } from "react";
// import Navbar from "../../Components/Navbar/NavBar";
import Modal from "../../Components/Kanban/Modal/Modal";
import styled from "styled-components";
import NewProduct from "../../Components/ProductModals/NewProduct";
// import { MoreHorizontal } from "react-feather";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import filterSign from "../../Images/filterSign.svg";
import { useSession } from "../../authentications/SessionContext";
import { productAction } from "../../Redux/Reducers/ProductSlice";
import {
  PAGINATION_DEFAULT_LIMIT,
  PRODUCT_EXPORT_FIELDS,
} from "../../utilities/constants";
// import { FaSearch } from "react-icons/fa";
import { unLink } from "../../DataApi/unlink";
import ReactSelect from "react-select";
import { handleResponse } from "../../utilities/handleResponse";
import { TableContainer } from "../../Components/StyledComponents/TableContainer/TableContainer";

// import Menu from "../../Components/Menu/Menu";
import { useLocation } from "react-router-dom";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
// import cameraIcon from "../../Images/camera.svg";
// import TableLoader from "../../Components/Loaders/TableLoader";
// import ActionButton from "../../Components/Buttons/ActionButton";
import { MainSectionOfPage } from "../../Components/StyledComponents/FirstSectonOfPages/MainSectionOfPage";
import TableHeader from "../../Components/Table/TableHeader";
import {
  PRODUCT_LIST_TABLE_VIEW,
  VTEX_PRODUCT_LIST_TABLE_VIEW,
} from "../../utilities/tables-view-constants";
import TableBody from "../../Components/Table/TableBody";
import Pagination from "../../Components/Table/TableFooter/Pagination";
import TableToolbar from "../../Components/Table/TableToolbar";
import { primaryColor } from "../../utilities/colors";
import ExcelReader from "../../Components/ImportXLSX/ExcelReader";
import ProductWizard from "../../Components/ProductModals/ProductWizard";
import { getToken } from "../../authentications/getCSRFToken";
import { exporttable } from "../../DataApi/Export/exportTable";
import { enqueueSnackbar } from "notistack";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";

const ProductTypeFilterListOption = [
  { label: "All Products", value: "" },
  { label: "Published", value: JSON.stringify(["is_published", "=", true]) },
  { label: "Serivce", value: JSON.stringify(["type", "in", ["service"]]) },
  {
    label: "Product",
    value: JSON.stringify(["type", "in", ["product", "consu"]]),
  },
];
const ProductSortListOption = [
  { label: "Creation Date", value: "create_date" },
  { label: "Name", value: "name" },
  { label: "Website", value: "website_id" },
  { label: "Barcode", value: "barcode" },
  { label: "Quantity", value: "qty_available" },
  { label: "Sale Price", value: "list_price" },
];

const NewButton = styled.button`
  border-radius: 15px;
  background-color: ${(props) =>
    props["data-isvtex"] ? "#000000" : "#ff5837"};
  color: ${(props) =>
    props["data-isvtex"] ? primaryColor.primary : "#ffffff"};
  border: none;
  width: 130px;
  min-width: 125px;
  height: 44px;
  margin-right: 10px;
`;
const ProductsContainer = styled.div`
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 2rem;
  margin: 30px;
  border-radius: 20px;
`;

const SearchDiv = styled.form`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  font-family: "Inter";

  input[type="text"] {
    width: 100%;
    padding: 10px;
    padding-left: 40px;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    margin-right: 10px;
    background-color: #f8f9fa;
    &:focus {
      border: none;
      outline: none;
    }
  }

  .search-container {
    position: relative;
    width: 100%;
  }
`;
const SearchIcon = styled.span`
  position: absolute; /* Position the icon absolutely */
  top: 50%;
  left: 2px;
  transform: translateY(-50%);
  color: #b0b7c3;
  cursor: pointer;
  padding: 12px;
`;

const Products = () => {
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX, is_vtex_admin } = sessionInfo;

  const { productsList, length, loading } = useSelector(
    (state) => state.product
  );
  const dispatch = useDispatch();

  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();

  // const [searchWithType, setSearchWithType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [productSort, setProductSort] = useState(
    ProductSortListOption[0].value
  );
  const [productTypeFilter, setProductTypeFilter] = useState(
    ProductTypeFilterListOption[0]
  );
  const [filterDirection, setFilterDirection] = useState("desc");
  const [isAllSelected, setIsAllSelected] = useState(false);

  const { language, translations } = useLanguage();
  const t = translations[language];
  const [selectedRows, setSelectedRows] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  // const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isProductWizardOpen, setIsProductWizardOpen] = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [wizardMode, setWizardMode] = useState("add");
  const categories = ["Electronic", "Fashion", "Clothes", "Health Care"];

  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const location = useLocation();
  // const [record,setRecord] = useState(null);

  // Access the state object passed from the previous component
  const stateData = location?.state;
  const shouldProductModalOpen = stateData ? stateData.openProductModal : false;
  // console.log("shouldProductModalOpen", shouldProductModalOpen);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handleRowClick = (record) => {
    // setIsDetailsModalOpen(true);
    setIsCreateModalOpen(true);
    setSelectedRecord(record);
  };
  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleCreateClick = () => {
    setIsCreateModalOpen(true);
  };
  const handleProductWizard = (mode) => {
    setWizardMode(mode);
    setShowWizard(true);
    setIsProductWizardOpen(true);
  };
  const handleProductWizardClose = () => {
    setShowWizard(false);

    setIsProductWizardOpen(false);
  };
  const handleImportModal = () => {
    setIsImportModalOpen(true);
    // console.log("import button clicked");
  };
  const fetchProductIds = async () => {
    try {
      const response = await callButtonGeneral({
        model: "product.template",
        method: "fetch_seller_products",
        args: [],
        context: {
          lang: "en_US",
          tz: "Asia/Muscat",
          uid: 7,
        },
      });

      console.log("Fetched product IDs:", response);

      if (
        response?.result?.status === "success" &&
        Array.isArray(response.result.product_ids)
      ) {
        return response.result.product_ids;
      } else {
        alert(
          "Failed to fetch product IDs: " + (response?.result?.message || "")
        );
        return [];
      }
    } catch (error) {
      console.error("Error fetching product IDs:", error);
      alert("Something went wrong while fetching product IDs.");
      return [];
    }
  };

  const handleExport = async (selectedIds) => {
    console.log("handleExport called with selected IDs:", selectedIds);

    const domain = [
      "&",
      ["company_id", "!=", false],
      ["type", "!=", "subscription"],
    ];

    try {
      let exportIds = [];

      if (isAllSelected) {
        exportIds = selectedRows; 
        console.log("Exporting all selected IDs:", exportIds);
      }
      else if (selectedIds && selectedIds.length > 0) {
        exportIds = selectedIds;
        console.log("Using manually selected IDs:", exportIds);
      }
      else {
        enqueueSnackbar("No product IDs selected for export!", {
          variant: "warning",
          preventDuplicate: true,
        });
        return;
      }

      const result = await getToken();
      const myCSRF = result?.token;

      if (!myCSRF) {
        enqueueSnackbar("CSRF token missing!", {
          variant: "error",
          preventDuplicate: true,
        });
        return;
      }

      const data = {
        model: "product.template",
        // fields: PRODUCT_EXPORT_FIELDS,
        ids: exportIds,
        domain: domain,
        groupby: [],
        context: context,
        import_compat: false,
      };

      const jsonString = JSON.stringify(data);
      const formdata = new FormData();
      formdata.append("data", jsonString);
      formdata.append("token", "dummy-because-api-expects-one");
      formdata.append("csrf_token", myCSRF);

      const dataObject = Object.fromEntries(formdata.entries());

      const downloadResponse = await exporttable(formdata, dataObject);

      if (downloadResponse?.status === 200) {
        const blob = await downloadResponse.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "product(s).xlsx";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(link);

        enqueueSnackbar("Export Operation Successful!", {
          variant: "success",
          preventDuplicate: true,
        });
      } else {
        enqueueSnackbar(
          "Something went wrong while exporting the product(s)!",
          {
            variant: "error",
            preventDuplicate: true,
          }
        );
      }
    } catch (error) {
      console.error("Error occurred while downloading", error);
      enqueueSnackbar("Export failed due to an error.", {
        variant: "error",
        preventDuplicate: true,
      });
    }
  };
  const handleImportModalClose = () => {
    setIsImportModalOpen(false);
  };
  const handleCloseModal = () => {
    setSelectedRecord([]);
    setIsCreateModalOpen(false);

    setSelectedRecord({});
    // setIsDetailsModalOpen(false);
  };

  const handleDeleteSelection = () => {
    setDisableModalButton(true);

    unLink({
      id: [...selectedRows],
      company_id,
      context,
      model: "product.template",
    }).then((response) => {
      response = JSON.parse(response);
      if (response.result) {
        refetchData();
        setSelectedRows([]);
        setOpenConfirmationModal(false);
      }
      handleResponse({
        response,
        setMetaData,
        setTitle,
        successMessage: "Product Deleted Successfully",
      });
      setDisableModalButton(false);
    });
  };

  const handleDeleteOrder = () => {
    setOpenConfirmationModal(true);
    setTitle("");
    setMetaData({
      dangerouslySetInnerHTML: "",
      primaryButton: "Yes",
      secondaryButton: "No",
    });
  };
  const handleEditOrder = (record) => {
    setIsCreateModalOpen(true);
    setSelectedRecord({ id: record });
  };
  // Update the toggleSelectAll function
  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows([]);
      setIsAllSelected(false);
    } else {
      fetchProductIds()
        .then((allProductIds) => {
          setSelectedRows(allProductIds);
          setIsAllSelected(true);
        })
        .catch((error) => {
          console.error("Error fetching product IDs:", error);
          enqueueSnackbar("Failed to select all products.", {
            variant: "error",
          });
        });
    }
  };

  const handleChangeProductTYpeFilter = (value, e) => {
    setProductTypeFilter(value);
  };
  const handleChangeProductSort = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handleChangeProductSortType = (e) => {
    setProductSort(e.target.value);
  };

  const refetchData = () => {
    dispatch(
      productAction.fetchProductData({
        context,
        company_id,
        pagination: {
          offset: (currentPage - 1) * itemsPerPage,
          limit: itemsPerPage,
        },
        search: {
          query: searchQuery,
          type: productTypeFilter?.value || "",
        },
        sort: {
          type: searchQuery.trim() !== "" ? "name" : productSort || "",
          dir: searchQuery.trim() !== "" ? "asc" : filterDirection,
        },
      })
    );
  };
  useEffect(() => {
  setCurrentPage(1);
}, [searchQuery, productTypeFilter]);

  useEffect(() => {
    refetchData();

  }, [
    currentPage,
    searchQuery,
    productSort,
    filterDirection,
    productTypeFilter,
  ]);
  useEffect(() => {
    if (shouldProductModalOpen) {
      handleCreateClick();
    } else {
      handleCloseModal();
    }
  }, [shouldProductModalOpen]);

  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
    // setIsDetailsModalOpen(false); // Close the details modal whenever a checkbox is clicked
  };

  const updatedProductsTableListView = useMemo(() => {
    let updatedList = isVTEX
      ? [...VTEX_PRODUCT_LIST_TABLE_VIEW]
      : [...PRODUCT_LIST_TABLE_VIEW];

    if (is_vtex_admin) {
      updatedList = updatedList.filter((col) => col.name !== "qty_available");
    }

    updatedList.splice(0, 1, {
      ...updatedList[0],
      handleCell: (data, item) => {
        return (
          <input
            type="checkbox"
            style={{ accentColor: isVTEX ? "#baf76a" : "#ff5837" }}
            // checked={
            
            //   data
            //     ? selectedRows.includes(data[item.name])
            //     : selectedRows.length === productsList?.length
            // }
            checked={
              data ? selectedRows.includes(data[item.name]) : isAllSelected 
            }
            onChange={() =>
              data ? toggleSelectRow(data[item.name]) : toggleSelectAll()
            }
          />
        );
      },
    });

    updatedList.splice(1, 1, {
      ...updatedList[1],
      handleCell: (data, item) => (
        <span role="button" onClick={() => handleEditOrder(data.id)}>
          {data[item.name]}
        </span>
      ),
    });

    return updatedList;
  }, [isVTEX, is_vtex_admin, selectedRows, productsList]);

  return (
    <>
      <Modal zIndex={true} isOpen={isImportModalOpen} importModalStyles={true}>
        <ExcelReader
          onClose={handleImportModalClose}
          reloadList={refetchData}
          handleProductWizardClose={handleProductWizardClose}
          wizardMode={wizardMode} //for 2 modes add or update
        />
      </Modal>
      <ConfirmationModal
        handleYes={handleDeleteSelection}
        handleNo={() => setOpenConfirmationModal(false)}
      />
      <Modal isOpen={isProductWizardOpen} onClose={handleProductWizardClose}>
        {showWizard && (
          <ProductWizard
            mode={wizardMode}
            show={showWizard}
            onClose={handleProductWizardClose}
            handleCreateClick={handleCreateClick}
            handleImportModal={handleImportModal}
          />
        )}
      </Modal>

      <MainSectionOfPage className="d-flex orders-first-section">
        <div className="d-none d-md-flex product_filter_div">
          {/* <p className="show_text">Show:</p> */}
          <ReactSelect
            value={productTypeFilter}
            options={ProductTypeFilterListOption}
            name="type"
            // isMulti={typeof productTypeFilter?.value === "" ? false : true}
            onChange={handleChangeProductTYpeFilter}
          />
        </div>
        <div className="btn_and_icons">
          {isVTEX && !is_vtex_admin && (
            <button
              className="btn btn-sm"
              onClick={() => handleProductWizard("update")}
              style={{
                background: isVTEX ? "#000000" : "#ff5837",
                color: isVTEX ? primaryColor.primary : "#FFFFFF",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                height: "44px",
                borderRadius: "15px",
              }}
            >
              <i className="bi bi-file-earmark-arrow-up-fill"></i>
              {t["Update Product(s)"]}
            </button>
          )}

          {isVTEX && !is_vtex_admin && (
            <button
              className="btn btn-sm"
              onClick={() => handleProductWizard("add")}
              style={{
                background: isVTEX ? "#000000" : "#ff5837",
                color: isVTEX ? primaryColor.primary : "#FFFFFF",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                height: "44px",
                borderRadius: "15px",
              }}
            >
              <i className="bi bi-file-earmark-arrow-up-fill"></i>{" "}
              {t["Add Product(s)"]}
            </button>
          )}

          {!isVTEX && (
            <NewButton onClick={handleCreateClick} data-isvtex={isVTEX}>
              + {t["New Product"]}
            </NewButton>
          )}
          {isCreateModalOpen && (
            <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
              <NewProduct
                selectedRecord={selectedRecord}
                handleCloseModal={(modalValue) => {
                  handleCloseModal();
                  setSelectedRows([]);
                  refetchData();
                }}
                refetchData={refetchData}
              />
            </Modal>
          )}
          <div className="d-none d-md-flex Filter_icon_div">
            <img
              src={filterSign}
              alt="filter"
              style={{
                transform: `rotate(${
                  filterDirection === "asc" ? "180" : "0"
                }deg)`,
              }}
              onClick={handleChangeProductSort}
            />
          </div>

          <div className=" d-none d-md-flex dropdown_list_div d-flex">
            <p className="sort_by">Sort by:</p>

            {/* {console.log(productSort, "productSort")} */}
            <select
              className="custom-select"
              onChange={handleChangeProductSortType}
              value={productSort}
              name="type"
            >
              {ProductSortListOption.map((option, index) => (
                <option
                  key={index}
                  value={option.value}
                  style={{ padding: "15px 0" }}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <button
            className="btn btn-sm d-none"
            onClick={handleImportModal}
            style={{
              background: isVTEX ? "#000000" : "#ff5837",
              color: isVTEX ? primaryColor.primary : "#FFFFFF",
              marginLeft: "1.5rem",
              marginRight: "1.5rem",
              height: "44px",
              borderRadius: "15px",
            }}
          >
            <i className="bi bi-file-earmark-arrow-up-fill"></i>{" "}
            {t["Import Products"]}
          </button>
        </div>
      </MainSectionOfPage>
      <ProductsContainer>
        <TableContainer data-isvtex={isVTEX}>
          <TableToolbar
            handleDelete={handleDeleteOrder}
            handleEditList={handleEditOrder}
            setSearchQuery={setSearchQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            showExportBtn={true}
            handleExport={handleExport}
          />
          <table className="table">
            <TableHeader tableHeaderList={updatedProductsTableListView} />
            <TableBody
              tableData={productsList}
              tableBodyList={updatedProductsTableListView}
              isLoadingData={loading === "pending" || loading === "idle"}
              checkIsLoadingData
            />
          </table>
          <Pagination
            ListViewData={productsList}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </TableContainer>
      </ProductsContainer>
    </>
  );
};

export default Products;
